import { Component, OnInit, AfterViewInit, ViewChild, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { LlmIntegrationService } from 'src/app/core/services/llm-integration.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AngularModalService } from 'src/app/core/services/modal.service';
import { FourDotFiveTimeStampFormatPipe } from 'src/app/core/pipes/four-dot-five-time-stamp-format';
import { CompanyService } from 'src/app/core/services/company.service';
import { UserService } from 'src/app/core/services/user.service';
import { CandidateService } from 'src/app/core/services/candidate.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { DateTimeUtilityService } from 'src/app/core/services/date-time-utility.service';
import { JobService } from 'src/app/core/services/job.service';

@Component({
  selector: 'app-ai-activities',
  templateUrl: './ai-activities.component.html',
  styleUrls: ['./ai-activities.component.css'],
  providers: [FourDotFiveTimeStampFormatPipe]
})
export class AiActivitiesComponent implements OnInit, AfterViewInit {

  @ViewChild('detailsModalTemplate', { static: true }) detailsModalTemplateRef: TemplateRef<any>;

  activities: any[] = [];
  allActivities: any[] = [];
  isLoading: boolean = true;

  detailsModal: BsModalRef;
  selectedActivity: any = null;

  // Filter state
  activityFilter: any = {};
  clientsOrBus: any[] = [];
  requisitions: any[] = [];
  users: any[] = [];
  startDate: string = '';
  startTime: string = '';
  endDate: string = '';
  endTime: string = '';
  isStaffingCompany: boolean = false;
  isFiltersEnabled: boolean = false;
  textSearch: string = '';

  constructor(
    private bsModalService: BsModalService,
    private llmService: LlmIntegrationService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private modalService: AngularModalService,
    private fourDotFiveTimeStampFormatPipe: FourDotFiveTimeStampFormatPipe,
    private companyService: CompanyService,
    private userService: UserService,
    private candidateService: CandidateService,
    private authService: AuthService,
    private dateTimeUtilityService: DateTimeUtilityService,
    private jobService: JobService
  ) { }

  ngOnInit() {
    this.isStaffingCompany = this.companyService.isStaffingCompany();
    this.activityFilter = {
      clientOrBuId: 'any',
      requisitionId: 'any',
      createdBy: 'any',
      startDate: null,
      endDate: null
    };

    this._getClientsOrBus();
    this._getRequisitions();
    this._getUsers();
    this.loadActivities();
  }

  ngAfterViewInit() {
    this._setSearchPanel();
    this.initializeDatePickers();
  }

  _getClientsOrBus() {
    this.candidateService.getAllClientsOrBu(this.authService.getUserDetails(), (data) => {
      this.clientsOrBus = data || [];
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  _getRequisitions(clientOrBuId?: string) {
    const userDetails = this.authService.getUserDetails();
    const clientOrBuIds = clientOrBuId && clientOrBuId !== 'any' ? [clientOrBuId] : [];
    const filter = { clientOrBuIds: clientOrBuIds, roleNames: [] };
    this.jobService.searchByReqNum(userDetails.id, userDetails.company.companyId, 'all', filter, (data) => {
      this.requisitions = data || [];
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  _getUsers() {
    this.userService.getCompanyUsersForActivities((data) => {
      this.users = data || [];
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  _setSearchPanel() {
    $(document).ready(() => {
      $('#ai-search-panel').hide();
      $(document).off('click', '#ai-open-filter').on('click', '#ai-open-filter', () => {
        $('#ai-search-panel').animate({ height: 'toggle' });
      });
    });
  }

  initializeDatePickers() {
    const currentDate = new Date();

    ($('#ai-startDate') as any).datepicker({
      format: 'M d, yyyy',
      endDate: currentDate,
      weekStart: 1,
      autoclose: true
    });

    ($('#ai-endDate') as any).datepicker({
      format: 'M d, yyyy',
      endDate: currentDate,
      weekStart: 1,
      autoclose: true
    });

    ($('#ai-startTime') as any).timepicker({
      minuteStep: 5,
      showSeconds: false,
      showMeridian: true,
      disableFocus: true,
      defaultTime: '12:00 AM'
    });
    ($('#ai-startTime') as any).timepicker('setTime', '12:00 AM');
    this.startTime = ($('#ai-startTime') as any).val();

    ($('#ai-endTime') as any).timepicker({
      minuteStep: 5,
      showSeconds: false,
      showMeridian: true,
      disableFocus: true,
      defaultTime: '11:59 PM'
    });
    ($('#ai-endTime') as any).timepicker('setTime', '11:59 PM');
    this.endTime = ($('#ai-endTime') as any).val();

    ($('#ai-startDate') as any).datepicker().on('changeDate', () => {
      this.startDate = ($('#ai-startDate') as any).val();
      this.activityFilter.startDate = this.dateTimeUtilityService.getDateTimeInAPIFormat(
        new Date(this.startDate + ' ' + this.startTime)
      );
      this.loadActivities();
    });

    ($('#ai-endDate') as any).datepicker().on('changeDate', () => {
      this.endDate = ($('#ai-endDate') as any).val();
      this.activityFilter.endDate = this.dateTimeUtilityService.getDateTimeInAPIFormat(
        new Date(this.endDate + ' ' + this.endTime)
      );
      this.loadActivities();
    });

    ($('#ai-startTime') as any).timepicker().on('changeTime.timepicker', () => {
      this.startTime = ($('#ai-startTime') as any).val();
      if (this.startDate) {
        this.activityFilter.startDate = this.dateTimeUtilityService.getDateTimeInAPIFormat(
          new Date(this.startDate + ' ' + this.startTime)
        );
        setTimeout(() => this.loadActivities(), 100);
      }
    });

    ($('#ai-endTime') as any).timepicker().on('changeTime.timepicker', () => {
      this.endTime = ($('#ai-endTime') as any).val();
      if (this.endDate) {
        this.activityFilter.endDate = this.dateTimeUtilityService.getDateTimeInAPIFormat(
          new Date(this.endDate + ' ' + this.endTime)
        );
        setTimeout(() => this.loadActivities(), 100);
      }
    });
  }

  onClientOrBuChange() {
    this.activityFilter.requisitionId = 'any';
    this._getRequisitions(this.activityFilter.clientOrBuId);
    this.loadActivities();
  }

  buildFilterPayload(): any {
    const selectedReq = this.activityFilter.requisitionId !== 'any'
      ? this.requisitions.find(r => r.reqNumber === this.activityFilter.requisitionId)
      : null;
    const payload: any = {
      companyId: this.authService.getUserDetails().company.companyId,
      clientOrBUId: this.activityFilter.clientOrBuId !== 'any' ? this.activityFilter.clientOrBuId : null,
      activityType: 'TEXT_FORMALIZATION',
      startDate: null,
      endDate: null,
      createdBy: this.activityFilter.createdBy !== 'any' ? this.activityFilter.createdBy : null,
      requisitionId: selectedReq ? selectedReq.jobId : null,
      requisitionNumber: selectedReq ? selectedReq.reqNumber : null,
      page: 0,
      size: 20000
    };

    if (this.activityFilter.startDate && this.activityFilter.startDate !== 'Invalid date') {
      payload.startDate = this.activityFilter.startDate;
    }
    if (this.activityFilter.endDate && this.activityFilter.endDate !== 'Invalid date') {
      payload.endDate = this.activityFilter.endDate;
    }

    this.isFiltersEnabled = !!(
      payload.createdBy ||
      payload.requisitionId ||
      payload.requisitionNumber ||
      payload.startDate ||
      payload.endDate ||
      (this.textSearch && this.textSearch.trim().length > 0)
    );

    return payload;
  }

  loadActivities() {
    this.isLoading = true;
    const filter = this.buildFilterPayload();

    this.llmService.getTextFormalizationFiltered(
      filter,
      (data: any[]) => {
        this.allActivities = this.processActivities(data);
        this.applyTextSearch();
        this.isLoading = false;
      },
      (error) => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        this.isLoading = false;
      }
    );
  }

  applyTextSearch() {
    if (!this.textSearch || this.textSearch.trim() === '') {
      this.activities = this.allActivities;
    } else {
      const search = this.textSearch.toLowerCase().trim();
      this.activities = this.allActivities.filter(a =>
        (a.candidateName && a.candidateName.toLowerCase().includes(search)) ||
        (a.requisitionDisplay && a.requisitionDisplay.toLowerCase().includes(search)) ||
        (a.companyName && a.companyName.toLowerCase().includes(search)) ||
        (a.userName && a.userName.toLowerCase().includes(search)) ||
        (a.originalText && a.originalText.toLowerCase().includes(search)) ||
        (a.formalizedText && a.formalizedText.toLowerCase().includes(search))
      );
    }
    this.isFiltersEnabled = !!(
      (this.activityFilter.createdBy && this.activityFilter.createdBy !== 'any') ||
      (this.activityFilter.requisitionId && this.activityFilter.requisitionId !== 'any') ||
      this.activityFilter.startDate ||
      this.activityFilter.endDate ||
      (this.textSearch && this.textSearch.trim().length > 0)
    );
  }

  resetFilters() {
    this.activityFilter.clientOrBuId = 'any';
    this.activityFilter.requisitionId = 'any';
    this.activityFilter.createdBy = 'any';
    this.activityFilter.startDate = null;
    this.activityFilter.endDate = null;
    this.textSearch = '';
    this.startDate = '';
    this.endDate = '';
    this._resetDateTimePicker();
    this._getRequisitions();
    this.loadActivities();
  }

  _resetDateTimePicker() {
    ($('#ai-startTime') as any).timepicker('setTime', '12:00 AM');
    ($('#ai-endTime') as any).timepicker('setTime', '11:59 PM');
  }

  processActivities(data: any[]): any[] {
    if (!data || !Array.isArray(data)) { return []; }

    return data
      .sort((a, b) => {
        const tA = a.dateRange && a.dateRange.startDate ? new Date(a.dateRange.startDate).getTime() : 0;
        const tB = b.dateRange && b.dateRange.startDate ? new Date(b.dateRange.startDate).getTime() : 0;
        return tB - tA;
      })
      .map((item, index) => {
        const startDate = item.dateRange && item.dateRange.startDate ? new Date(item.dateRange.startDate) : null;
        const endDate = item.dateRange && item.dateRange.endDate ? new Date(item.dateRange.endDate) : null;

        const candidate = item.candidate || {};
        const requisition = item.requisition || {};
        const jobMatch = item.jobMatch || {};
        const company = item.company || {};
        const user = item.user || {};

        // Prefer requisition for display; fall back to jobMatch fields
        const reqDisplay = requisition.requisitionName || jobMatch.requisitionName
          || requisition.requisitionId || jobMatch.requisitionId || '--';
        const reqId = requisition.requisitionId || jobMatch.requisitionId || null;
        const jobId = requisition.jobId || jobMatch.jobId || null;

        return {
          ...item,
          serialNumber: index + 1,
          // Date / time
          formattedTimestamp: startDate ? this.fourDotFiveTimeStampFormatPipe.transform(startDate) : '--',
          formattedEndTimestamp: endDate ? this.fourDotFiveTimeStampFormatPipe.transform(endDate) : '--',
          // Scalar fields
          activityType: item.activityType || '--',
          duration: item.duration != null ? item.duration : '--',
          sourceScreen: item.sourceScreen || '--',
          externalNote: item.externalNote || null,
          mode: this.toSentenceCase(item.mode || '--'),
          tone: this.toSentenceCase(item.tone || '--'),
          originalText: item.originalText || '--',
          formalizedText: item.formalizedText || '--',
          savedNote: item.savedNote || '--',
          noteId: item.noteId || null,
          // Candidate
          candidateName: candidate.firstName || candidate.lastName
            ? (`${candidate.firstName || ''} ${candidate.lastName || ''}`).trim()
            : '--',
          candidateId: candidate.candidateId || null,
          // Requisition / jobMatch
          requisitionDisplay: reqDisplay,
          requisitionId: reqId,
          jobId: jobId,
          jobMatchId: jobMatch.jobMatchId || null,
          // Company
          companyName: company.companyName || '--',
          companyId: company.companyId || null,
          clientOrBUName: company.clientOrBUName || '--',
          clientOrBUId: company.clientOrBUId || null,
          // User
          userName: user.firstName || user.lastName
            ? (`${user.firstName || ''} ${user.lastName || ''}`).trim()
            : '--',
          userEmail: user.email || '--',
          userId: user.userId || null,
        };
      });
  }

  toSentenceCase(value: string): string {
    if (!value || value === '--') { return value; }
    return value
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }

  viewActivityDetails(row: any) {
    this.selectedActivity = row;
    this.detailsModal = this.bsModalService.show(this.detailsModalTemplateRef, {
      class: 'modal-lg custom-ngx-modal custom-candidate-job-match-modal',
      backdrop: false,
      ignoreBackdropClick: true
    });
    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
  }

  closeDetailsModal() {
    if (this.detailsModal) {
      this.detailsModal.hide();
    }
  }
}
